import { Component, inject } from '@angular/core';
import { ForwarderService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import {
  ForwarderCreateDto,
  ForwarderDto,
  ForwarderExcelDownloadDto,
  ForwarderUpdateDto,
} from '../proxy/general/dtos/forwarder';
import { FORWARDER_CONFIG, FORWARDER_FIELDS } from './forwarder.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-forwarder',
  imports: [
    CommonModule,
    CrudPage,
    GenericForm,
    ZnHierarchicalViewComponent
  ],
  providers: [ListService, ForwarderService, ConfirmationService],
  templateUrl: './forwarder.html',
  styleUrl: './forwarder.scss',
})
export class Forwarder extends BaseHierarchicalCrudComponent<
  ForwarderDto,
  ForwarderCreateDto,
  ForwarderUpdateDto,
  ForwarderExcelDownloadDto
> {
  service = inject(ForwarderService);
  config = FORWARDER_CONFIG;
  fields = FORWARDER_FIELDS;

  protected prepareUpdateDto(data: any, selected: ForwarderDto): ForwarderUpdateDto {
    return {
      machineId: data.machineId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Forwarder';
  }
}
